import TasksModule from '@modules/TasksModule';
import { ITask } from '@modules/TasksModule/types';
import { SPEED_TO_LEAD_OUTBOUND_TASK_TYPE } from '../types';

/**
 * Finds an STL task that matches the given phone number for an outbound call.
 * Requires `hasMadeCall` to be true — ensures we only match after the agent
 * has actually placed a call from the STL task.
 */
export function findStlTaskForCall(remoteIdentity: string): ITask | undefined {
  return TasksModule.getTasks().find(
    (t) =>
      t.type === SPEED_TO_LEAD_OUTBOUND_TASK_TYPE &&
      t.attributes.hasMadeCall &&
      remoteIdentity &&
      t.from.includes(remoteIdentity),
  );
}
